import * as actionTypes from './actionTypes';
import { fetchCandidateRole } from "../../../services/candidate.service";

export const setCandidateRole = (data) => {
  return {
    type: actionTypes.SET_CANDIDATES_ROLE,
    data,
  }
}

export const getCandidatesRole = (params= "") => {
  return dispatch => {
    return fetchCandidateRole(params).then(res => {
      dispatch(setCandidateRole(res?.data));
      return res;
    }).catch(err => {
      console.log(err);
      return [];
    });
  }
}
